import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import { Paginator } from 'primereact/paginator';

function App() {
    const [Data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState(Data?.data);
    const [first, setFirst] = useState(0); 
    const [rows, setRows] = useState(10); 
   
    const fetchData = async (offset) => {
        try {
            const sendData = {next: offset}
            const response = await axios.get('https://api.trucoo.in/payment/allpaymentmade/', {params: sendData});
            setData(response.data);
            console.log(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData(0);
    }, []); 

    const handleSearchInputChange = (event) => {
        const query = event.target.value;
        setSearchQuery(query);
      
        // Filter Data.data based on search query
        const filtered = Data?.data?.filter(payment =>
            payment.expensesType.toLowerCase().includes(query.toLowerCase()) ||
            payment.expenses.toLowerCase().includes(query.toLowerCase()) ||
            payment.date.toLowerCase().includes(query.toLowerCase())
        );
        setFilteredData(filtered);
    };

    const onPageChange = (event) => {
        setFirst(event.first);
        fetchData(event.first);
    };

    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="col-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <a href="/addPaymentMade" className="waves-effect waves-light btn mb-5 bg-gradient-info" style={{float: "right"}}>
                                        Add Payment Made
                                    </a>
                                    <h4 className="box-title">Payment Made</h4>
                                </div>
                                
                                <div className="box-body">
                                    <div className="table-responsive">
                                        <div id="example_filter" className="dataTables_filter">
                                            <label>
                                                <input 
                                                    type="search" 
                                                    className="form-control form-control-sm mb-5"  
                                                    placeholder="Search by expenses type, expenses or date" 
                                                    value={searchQuery}
                                                    onChange={handleSearchInputChange} 
                                                    style={{left:'10px'}} 
                                                    aria-controls="example"
                                                />
                                            </label>
                                        </div>
                              
                                             <table className="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                     
                                            <thead>
                                                <tr className="text-dark">
                                                    <th>SI.NO</th>
                                                    <th>Expenses Type</th>
                                                    <th>Expenses</th>
                                                    <th>Amount</th>
                                                    <th>Month</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {searchQuery && filteredData?.length > 0 ? (
                                                    <>
                                                        {filteredData.map((payment, index) => ( 
                                                            <tr key={payment.id}>
                                                                <td>{index + 1}</td>
                                                                <td className="text-dark">{payment.expensesType}</td>
                                                                <td>{payment.expenses}</td>
                                                                <td>{payment.amount}</td>
                                                                <td>{payment.date}</td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                ) : searchQuery && filteredData?.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="5">No payments found</td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        {Data?.data?.map((payment, index) => (
                                                            <tr key={payment.id}>
                                                                <td>{index + 1}</td>
                                                                <td className="text-dark">{payment.expensesType}</td>
                                                                <td>{payment.expenses}</td>
                                                                <td>{payment.amount}</td>
                                                                <td>{payment.date}</td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                )}
                                            </tbody>	
                                        </table>
                                        <Paginator 
                                            className="custom-paginator" 
                                            first={first} 
                                            rows={rows} 
                                            totalRecords={Data?.ReadCount}  
                                            onPageChange={onPageChange} 
                                        />
                                    </div>              
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default App;